import * as React from 'react';

import {ListView} from 'shells/list-view/list-view';
import {MetricRow} from 'shells/metric-row/metric-row';
import type {MetricValue} from 'shells/metric-row/metric-row';

// @ts-expect-error
import {MetricErrorState} from './metric-error-state';

import styles from './metrics.module.css';

type DashboardMetric = {
    currentValue: MetricValue;
    previousValue: MetricValue;
    deltaDirection: 'up' | 'down' | 'neutral';
    deltaMood: 'positive' | 'negative' | 'neutral';
    htmlUrl: string;
    id: string;
    metricType: 'sales' | 'newleads' | 'openleads';
    name: string;
    periodDisplayString: string;
    periodString: string;
    type: 'dashboardMetrics';
};

type Props = {
    dashboardMetrics: DashboardMetric[];
};

export class Metrics extends React.Component<Props> {
    render() {
        return (
            <div className={styles.container}>
                <ListView
                    collection={this.props.dashboardMetrics}
                    renderRow={this.renderRow}
                    specialStates={[
                        {
                            shouldRender: () => !this.props.dashboardMetrics,
                            component: <MetricErrorState />,
                        },
                    ]}
                />
            </div>
        );
    }

    renderRow = (dashboardMetric: DashboardMetric) => {
        return (
            <MetricRow
                key={dashboardMetric.id}
                {...dashboardMetric}
                timespanString={dashboardMetric.periodDisplayString}
            />
        );
    };
}
